import { render } from "./template.html?vue&type=template&id=200c055a&scoped=true"
import script from "./stories.vue?vue&type=script&lang=js"
export * from "./stories.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=200c055a&lang=scss&scoped=true"

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200c055a"]])

export default __exports__